import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Lock from '../Icons/Lock.svg';
import Loader from '../Icons/Loader';

class ProjectInfos extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	redirectToProject: false
	    };
	}

	seeProject(){
		this.setState({
	    	redirectToProject: true
	    })
	}

	declineInvite(value){
		this.props.actions.answerInvite(this.props.project_id,value);
	}

	render() {
		return (
			<div className="projectInfo">
				<div className="notifRight">
					{this.props.current_amount >= this.props.target && !this.props.achieved_at &&
						<div className="notifBloc">
							<div className="validDot"></div>
							<div className="validLabel">Baaacked</div>
						</div>
					}
					{this.props.privacy === 1 &&
						<div className="notifBloc privacy">
							<div className="validLabel">
								<img src={Lock} alt="Private project" title="Private project" className="lock" />
							</div>
						</div>
					}
				</div>
				{this.props.privacy === 1 && this.props.has_accepted_invite === 0 && this.props.currentUser.email !== this.props.creator_email && !this.props.achieved_at &&
					<div className="notifLeft">
						<button className="notifBloc" onClick={() => this.seeProject()} disabled={this.props.answerIsLoading}>
							{this.props.answerIsLoading ? 
								<div>
									<Loader color="#000" />
								</div> : (
								<div>
									<div className="validDot"></div>
									<div className="validLabel">
										See the project
									</div>
								</div>)
							}
						</button>
						<button className="notifBloc" onClick={() => this.declineInvite(2)} disabled={this.props.answerIsLoading}>	
							{this.props.answerIsLoading ? 
								<div>
									<Loader color="#000" />
								</div> : (
								<div>
									<div className="validDot red"></div>
									<div className="validLabel">
										Decline
									</div>
								</div>)
							}
						</button>
					</div>
				}
				{this.props.achieved_at &&
					<div className="notifLeft">
						<div className="notifBloc achieve">
							<div>
								<div className="validDot"></div>
								<div className="validLabel">Sheeped</div>
							</div>
						</div>
					</div>
				}
				{this.state.redirectToProject &&
		          <Redirect to={'/projects/' + this.props.project_id}/>
		        }
			</div>
		);
	}
}

export default ProjectInfos;



// WEBPACK FOOTER //
// ./src/components/Explore/ProjectInfos.js